/**
 * react-select styles for ReactTimezoneSelect — fixes dark mode where default
 * option hover (#DEEBFF) kept light text from the menu, making rows unreadable.
 */
export function buildTimezoneSelectStyles(isDark, options = {}) {
  const { controlAndMenuWidth, menuPortalZIndex, accentColor, fontSize } = options;
  const text = isDark ? "#fff" : "#222";
  const surface = isDark ? "#23272b" : "#fff";
  const optionHover = isDark ? "rgba(255,255,255,0.14)" : "#DEEBFF";
  const optionSelected = accentColor || (isDark ? "rgba(25,118,210,0.55)" : "#2684FF");

  const widthPatch = controlAndMenuWidth
    ? { width: controlAndMenuWidth }
    : {};
  const fontSizePatch = fontSize ? { fontSize } : {};

  const styles = {
    control: (base) => ({
      ...base,
      ...widthPatch,
      ...fontSizePatch,
      background: surface,
      color: text,
      borderColor: isDark ? "#555" : base.borderColor,
    }),
    menu: (base) => ({
      ...base,
      ...widthPatch,
      background: surface,
      color: text,
    }),
    menuList: (base) => ({
      ...base,
      background: surface,
    }),
    singleValue: (base) => ({ ...base, ...fontSizePatch, color: text }),
    placeholder: (base) => ({
      ...base,
      ...fontSizePatch,
      color: isDark ? "#9e9e9e" : "#757575",
    }),
    input: (base) => ({ ...base, ...fontSizePatch, color: text }),
    option: (base, state) => ({
      ...base,
      ...fontSizePatch,
      cursor: "pointer",
      backgroundColor: state.isSelected
        ? optionSelected
        : state.isFocused
          ? optionHover
          : surface,
      color: state.isSelected ? "#fff" : text,
    }),
  };

  if (menuPortalZIndex != null) {
    styles.menuPortal = (base) => ({ ...base, zIndex: menuPortalZIndex });
  }

  return styles;
}
